import { render, staticRenderFns } from "./TeamStats.vue?vue&type=template&id=6329dc7e&scoped=true&"
import script from "./TeamStats.vue?vue&type=script&lang=js&"
export * from "./TeamStats.vue?vue&type=script&lang=js&"
import style0 from "./TeamStats.vue?vue&type=style&index=0&id=6329dc7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6329dc7e",
  null
  
)

export default component.exports